import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { Checkbox } from "antd";
import { isEqual } from "lodash";

const CheckboxGroup = Checkbox.Group;

const VerticalCheckboxGroup: React.FC = ({
  options,
  onSelect,
  selected
}: any) => {
  const { t } = useTranslation();
  // Transform the options to fit Checkbox.Group
  const transformedOptions = options.map((item) => {
    const key = Object.keys(item)[0];
    return { label: item[key], value: key };
  });

  const [selectedValues, setSelectedValues] = useState<string[]>(selected || []);

  useEffect(() => {
    if (!selected?.length) return;
    if (!isEqual(selected, selectedValues)) {
      setSelectedValues(selected)
    }
  }, [selected])

  useEffect(() => {
    if (onSelect) onSelect(selectedValues)
  }, [selectedValues, onSelect]);

  const handleChange = (checkedValues: string[]) => {
    setSelectedValues(checkedValues);
  };

  return (
    <div>
      <div className="header-right-options-title">
        {t('Related Sensors')}
      </div>
      <CheckboxGroup
        value={selectedValues}
        onChange={handleChange}
        className="vertical-checkbox"
      >
        {transformedOptions.map((option) => (
          <div key={option.value} className="header-right-options-margin">
            <Checkbox value={option.value}>{t(option.label)}</Checkbox>
          </div>
        ))}
      </CheckboxGroup>
    </div>
  );
};

export default VerticalCheckboxGroup;
